module.exports = __webpack_public_path__ + "static/media/29ADMSPC15.e46ca196.jpg";